import pdfMake from 'pdfmake/build/pdfmake';
import {ContentTable, TDocumentDefinitions} from "pdfmake/interfaces";
import {formatDate, formatPeso} from '../helpers';
import { getPrestamo } from '../services';
import {IPrestamoDetalle} from "../redux/types/IPrestamo";
import {store} from "../redux/store";
import {getColor} from "../assets/colors";
const fonts = require('./fonts/fonts');


export async function reporteDetallesPrestamo(preID:number, noMostrar:string[]) {
    let compania = store.getState().companias.data;
    let {uiColor} = store.getState().auth.user ?? {};
    let color = getColor(uiColor)

    let response =  await getPrestamo(preID);



    pdfMake.vfs = fonts.pdfMake.vfs;
    pdfMake.fonts = {
        'Calibri': {
            normal: `Calibri_Regular.ttf`,
            bold: `Calibri_Bold.ttf`,
            italics: `Calibri_Light_Italic.ttf`,
            bolditalics: `Calibri_Bold_Italic.ttf`
        },
    }


    let data=  response.data as IPrestamoDetalle;
    let pagos = data.pagos?.filter(p=>!p.fechaAnulacion)
    let showSeguro = pagos?.some(p=>!!p.seguro);

    let docDefinition:TDocumentDefinitions = {
        pageMargins:20,
        info: {
            title: 'Detalle de préstamo '+data?.cliente,
            author: 'dsegura.net',
            creator: 'prestamistapp.com',
        },
        // pageOrientation:'landscape',
        content: [
            {
                layout:"noBorders",
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            compania?.logo ?
                            {
                                image: "logo",
                                fit: [70, 50],
                                // opacity: 0.5,
                                marginTop: 7
                            }:{},
                            [
                                {text: compania?.nombre ?? "", alignment:"right", fontSize:17, color:color.primary.main},
                                ...(compania?.rnc ? [{text: "RNC: "+compania?.rnc, alignment: "right"}]: []),
                                {text: [
                                        "Tel: "+ compania?.telefono ?? "",
                                        (compania?.telefono2 ? " / "+compania.telefono2 : ""),
                                    ], alignment:"right", fontSize:10},

                                {text: compania?.direccion ?? "" , alignment:"right", fontSize:10},
                            ]
                        ],
                    ]
                }
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 555,
                        y2: 10,
                        lineWidth: 0.5,
                        lineColor:"#d3d3d3",
                        strokeOpacity:0.5
                    }
                ],
                marginBottom:10,
            },
            {text: "DETALLE DE PRÉSTAMO", alignment:"center", fontSize:17,margin:[0,10], color: color.primary.main},
            {
                layout:"noBorders",
                fillColor:"#f5f5f5",
                marginBottom:4,
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            {text: data.cliente, fontSize:15, color:color.primary.main, margin: 4},
                            {text: data.cuotasAtrasadas+" Cuotas pendientes",
                                fontSize:12,
                                marginRight: 6,
                                marginTop:5,
                                alignment: "right",
                                bold: false,
                                color : (data.cuotasAtrasadas ?? 0 ) > 0  ? "#df8500" : undefined
                            },

                        ],
                    ]

                }
            },


            {
                layout:"noBorders",
                table: {
                    widths: !!data.clienteAvatar ? [75,"*"]:["*"],
                    body: [
                        [
                            ...(!!data.clienteAvatar?
                                [{
                                    image: "foto",
                                    width: 75,
                                    // opacity: 0.5,
                                }]
                                :[]
                            ),


                            {
                                layout:"noBorders",
                                margin:5,
                                fillColor:"#f5f5f5",
                                table: {
                                    widths: ['*', '*', '*'],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {text: "Código/Ref.: ", bold:true}, {text: data.referencia},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Fecha apertura: ", bold:true}, {text: formatDate(data.fecha)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Creado por: ", bold:true}, {text: data.usuarioIdAgente},
                                                ],
                                                marginBottom: 4
                                            },
                                        ],
                                        [
                                            {
                                                text: [
                                                    {text: "Capital actual: ", bold:true}, {text: formatPeso(data.capitalActual)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Cuotas: ", bold:true}, {text: data.plazoString},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Amortización: ", bold:true}, {text: data.tipoAmortizacionString},
                                                ],
                                                marginBottom: 4
                                            },
                                        ],
                                        [
                                            {
                                                text: [
                                                    {text: "Próximo Pago: ", bold:true}, {text: formatDate(data.fechaProximoPago)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Interés: ", bold:true}, {text: data.tasaInteres+" %"},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Capital inicial: ", bold:true}, {text: formatPeso(data.capitalInicial)},
                                                ],
                                                marginBottom: 4
                                            },
                                        ],
                                        [
                                            {
                                                text: [
                                                    {text: "Balance pendiente: ", bold:true}, {text: formatPeso(data.balancePendiente)},
                                                ]
                                            },
                                            {
                                                text: [
                                                    {text: "Modalidad: ", bold:true}, {text: data.ciclosPagoString},
                                                ]
                                            },
                                            {
                                                text: [
                                                    {text: "Parcial pendiente: ", bold:true}, {text: formatPeso(data.pagoPendiente)},
                                                ]
                                            },
                                        ],
                                    ]

                                }
                            },
                        ]
                    ]

                }
            },

            ...(!noMostrar.includes("pagos") ?[
                {
                    layout:"noBorders",
                    fillColor:"#f5f5f5",
                    marginTop:4,
                    marginBottom:1,
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {text: "Pagos realizados", fontSize:12, bold:true, color:color.secondary.main, margin:[8,4]},
                            ],
                        ]

                    }
                },
                {
                    fontSize:10,
                    table: {
                        widths: [50,'*','*','*','*','*',...( !!showSeguro ? ["*"]:[]), 80],
                        body: [

                            ...(!!pagos?.length ? [
                                [
                                    // {text: "Concepto", style:"titleCel"},
                                    {text: "Fecha", style:"titleCel"},
                                    {text: "Capital", alignment:"right", style:"titleCel"},
                                    {text: "Interés", alignment:"right", style:"titleCel"},
                                    ...(showSeguro ? [{text: "Seguro", alignment:"right", style:"titleCel"}]:[]),
                                    {text: "Mora", alignment:"right", style:"titleCel"},
                                    {text: "Descuento", alignment:"right", style:"titleCel"},
                                    {text: "Total Pagado", alignment:"right", style:"titleCel"},
                                    {text: "Capital Restante", alignment:"right", style:"titleCel"},
                                ],
                                ...pagos?.map((item)=>{
                                    return [
                                        [
                                            {text: item.concepto??"",colSpan: showSeguro ? 8 : 7, bold:true,italics: true, color:"#666"},
                                        ],
                                        [
                                            // {text: item.concepto??""},
                                            {text: formatDate(item.fecha)},
                                            {text: formatPeso(item.capital), alignment:"right"},
                                            {text: formatPeso(item.interes), alignment:"right"},
                                            ...(showSeguro ? [{text: formatPeso(item.seguro), alignment:"right"}] : []),
                                            {text: formatPeso(item.mora), alignment:"right"},
                                            {text: formatPeso(item.descuento), alignment:"right"},
                                            {text: formatPeso(item.totalPago), alignment:"right"},
                                            {text: formatPeso(item.nuevoCapital), alignment:"right"},
                                        ]
                                    ]
                                }).reduce((a, c) => {
                                    return a.concat(c);
                                }),
                                (!noMostrar.includes("total")?[
                                    {text: "TOTALES:", style:"footerCel"},
                                    {text: formatPeso(pagos?.reduce((a, b) => +a + (b.capital??0), 0)), alignment:"right", style:"footerCel"},
                                    {text: formatPeso(pagos?.reduce((a, b) => +a + (b.interes??0), 0)), alignment:"right", style:"footerCel"},
                                    ...(showSeguro ? [{text: formatPeso(pagos?.reduce((a, b) => +a + (b.seguro??0), 0)), alignment:"right", style:"footerCel"}] : []),
                                    {text: formatPeso(pagos?.reduce((a, b) => +a + (b.mora??0), 0)), alignment:"right", style:"footerCel"},
                                    {text: formatPeso(pagos?.reduce((a, b) => +a + (b.descuento??0), 0)), alignment:"right", style:"footerCel"},
                                    {text: formatPeso(pagos?.reduce((a, b) => +a + (b.totalPago??0), 0)), alignment:"right", style:"footerCel"},
                                    {text: "", alignment:"right", style:"footerCel"}
                                ]:[{text: "", colSpan: showSeguro ? 8 : 7}])

                            ]:[
                                [
                                    {text: "No hay pagos realizados",colSpan: showSeguro ? 8 : 7 , margin:10, alignment: "center"},
                                ],
                            ]),

                        ]
                    },
                    layout: {
                        hLineWidth: (i:number, node:any) =>  {
                            if(i === 0 || i === node.table.body.length){
                                return 0
                            }else if(i === 1){
                                return 2
                            }else if(i % 2 === 0){
                                return 0
                            }
                            return 1;
                        },
                        vLineWidth: () =>  {
                            return 0
                            // return (i === 0 || i === node.table.widths?.length) ? 0 : 1;
                        },
                        hLineColor: (i:number) =>  {
                            if(i === 1){
                                return color.primary.main;
                            }
                            return '#e3e3e3';

                        },
                        // vLineColor: function (i, node) {
                        //     return null;
                        // },
                        // hLineStyle: function (i, node) {
                        //     if (i === 0 || i === node.table.body.length) {
                        //         return null;
                        //     }
                        //     return {dash: {length: 10, space: 4}};
                        // },
                        // vLineStyle: function (i, node) {
                        //     if (i === 0 || i === node.table.widths?.length) {
                        //         return null;
                        //     }
                        //     return {dash: {length: 4}};
                        // },
                        paddingLeft: () => { return 5; },
                        paddingRight: () =>  { return 5; },
                        paddingTop: () =>  { return 5; },
                        paddingBottom: (i:number) =>  {
                            if(i % 2){
                                return 0;

                            }
                            return 5;
                        },
                        fillColor: (i:number) =>  {
                            if (i === 0){
                                return "#f5f5f5";
                            }
                            return null;
                        }
                    }
                },
            ]:[]),



            ...(!noMostrar.includes("amortizacion") ?[
                {
                    layout:"noBorders",
                    fillColor:"#f5f5f5",
                    marginTop:10,
                    marginBottom:1,
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {text: "Amortización", fontSize:12, bold:true, color:color.secondary.main, margin:[8,4]},
                            ],
                        ]

                    }
                },
                {
                    fontSize:10,
                    table: {
                        widths: ['*','*','*','*','*'],
                        body: [
                            [
                                {text: "No - Fecha", style:"titleCel"},
                                {text: "Balance", alignment:"right",style:"titleCel"},
                                {text: "Capital", alignment:"right", style:"titleCel"},
                                {text: "Interés", alignment:"right", style:"titleCel"},
                                {text: "Cuota", alignment:"right", style:"titleCel"}
                            ],
                            ...data.amortizacion?.map((item, index)=>[
                                {text: item.cuota+" - "+formatDate(item.fecha)},
                                {text: formatPeso(item.capitalPendiente), alignment:"right"},
                                {text: formatPeso(item.capital), alignment:"right"},
                                {text: formatPeso(item.interes), alignment:"right"},
                                {text: formatPeso(item.total), alignment:"right"},
                            ]) ?? [],

                            (!noMostrar.includes("total")?[
                                {text: "TOTALES:", style:"footerCel"},
                                {text: "",style:"footerCel"},
                                {text: formatPeso(data.capitalInicial), alignment:"right", style:"footerCel"},
                                {text: formatPeso(data.amortizacion?.reduce((a, b) => +a + (b.interes??0), 0)), alignment:"right", style:"footerCel"},
                                {text: formatPeso(data.amortizacion?.reduce((a, b) => +a + (b.total??0), 0)), alignment:"right", style:"footerCel"}
                            ]:[{},{},{},{},{}]),






                        ],

                    },
                    layout: {
                        hLineWidth: function (i:number, node:ContentTable) {
                            if(i === 0 || i === node.table.body.length){
                                return 0
                            }else if(i === 1){
                                return 2
                            }
                            return 1;
                        },
                        vLineWidth: function (i:number, node:ContentTable) {
                            return 0
                        },
                        hLineColor: function (i:number, node:ContentTable) {
                            if(i === 1){
                                return color.primary.main;
                            }
                            return '#e3e3e3';

                        },

                        paddingLeft: function(i:number, node:ContentTable) { return 5; },
                        paddingRight: function(i:number, node:ContentTable) { return 5; },
                        paddingTop: function(i:number, node:ContentTable) { return 5; },
                        paddingBottom: function(i:number, node:ContentTable) { return 5; },
                        fillColor: function (i:number, node:ContentTable) {
                            if (i === 0){
                                return "#f5f5f5";
                            }
                            return null;
                        }
                    }
                },
                ]:[]
            ),
        ],
        footer: {
            margin:[16,0],
            columns: [
                {
                    text: [
                        'www.prestamistapp.com'
                    ],
                    link: 'https://prestamistapp.com/',
                    color:"blue",
                    alignment:"right",
                    fontSize:10,
                },
                // {
                //     text: "Sistema para Administración de Prestamos.",
                //     alignment: 'right'
                // }
            ]
        },
        styles: {
            blueCell:{
                fillColor:"#bbbbbb",
            },

            blueCellBold:{
                fillColor:"#bbbbbb",
                bold: true,

            },
            footerCel:{
                bold:true,
                color:"#666"
                // fillColor:"#f5f5f5",
                // fontSize: 11
            },
            titleCel:{
                // fillColor:"#f5f5f5",
                color:color.primary.main,
                margin :2,
                fontSize: 11,
                // color: '#FFF',
                bold: true,
              //  fontSize: 8,
            },
            table: {
                margin: [0, 5, 0, 5],
            },
            tableHeader: {
                bold: true,
               // fontSize: 11,
              //  fillColor:"#023465",
                color: 'black'
            }
        },
        images:{
          foto: data.clienteAvatar ?? "data:image/jpeg;base64,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",
          logo: compania?.logo ?? ""
        },
        defaultStyle: {
            fontSize: 11,
            font: 'Calibri'
            // alignment: 'justify'
        }
    }


    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    return Promise.resolve(pdfDocGenerator);
}


export interface IFormulario {
    idSolicitud: number
    generales: Generales
    relacionBanco: {
        tipoProducto?: string
        codigoProducto?: string
        montoOriginal?: number
        capital?: number
        cuota?: number
        atraso?: number
        montoVencido?: number
        tipoRelacion?: string
        estadoProducto?: string
        claseProducto?: string
    }[]
}

export interface Generales {
    nombre: string
    fecha: string
    identificacion: string
}
